import { messgeraet, wartungsintervall, messgeraettyp } from './../../../utils/apiTypes';
import {
  messgereatState,
  zeitsynchronisationsart,
} from "./messgeraeteTypes";
import { AnyAction, createSlice, PayloadAction, ThunkAction } from "@reduxjs/toolkit";
import { deleteWithAuth, getWithAuth, postJsonWithAuth, putWithAuth } from "../../../utils/api";
import type { RootState, AppDispatch } from "../../../app/store";
import { logError } from "../../../utils/utils";
import { openSnackbar } from "../../../features/snackbar/globalSnackbarSlice";
import { GridSortModel } from '@material-ui/data-grid';
import { errorHandler } from '../../../utils/errorHandling';


export const messgeraetDummy: messgeraet = {
  id: 0,
  seriennummer: "",
  herstellungsjahr: new Date().getFullYear(),
  firmware: "",
  macadresse: null,
  kommentar: null,
  inbetriebnahmedatum: null,
  wartungsintervall: null,
  zeitsynchronisationsart: null,
  typ: -1,
  ipadresse: null,
  subnetzmaske: null,
  zugeordnet: false,
  jemalsZugeordnet: false
};

const initialState: messgereatState = {
  editEntry: false,
  newEntry: false,
  messgeraetListe: [],
  altesMessgeraet: messgeraetDummy,
  aktuellesMessgereat: messgeraetDummy,
  zsList: [],
  messgeraettypList: [],
  editDirty: 0,
  viewMode: false,
  error: [],
  wartungsintervalle: [],
  listLoading: false,
  messgeraettypenLoading: false,
  zeitsynchroLoading: false,
  wartungsintervallLoading: false,
  sorting: [
    {
      field: 'seriennummer',
      sort: 'asc',
    },
  ]
};

const messgereateSlice = createSlice({
  name: "messgereate",
  initialState,
  reducers: {
    updateMessgeraete: (state, action: PayloadAction<messgeraet>) => {
      const updateIndex = state.messgeraetListe.findIndex(
        (x: messgeraet) => x.id == action.payload.id
      );
      const firstPart = state.messgeraetListe.slice(0, updateIndex);
      let lastPart = Array<messgeraet>();
      if (updateIndex + 1 < state.messgeraetListe.length)
        lastPart = state.messgeraetListe.slice(updateIndex + 1);
      state.messgeraetListe = [...firstPart, action.payload, ...lastPart].sort((a, b) => a.seriennummer.localeCompare(b.seriennummer));
    },
    addAktuellesMessgeraetToMessgeraete: (state) => {
      const messgeraetArray = state.messgeraetListe;
      messgeraetArray.push(state.aktuellesMessgereat);
      state.messgeraetListe = [...messgeraetArray].sort((a, b) => a.seriennummer.localeCompare(b.seriennummer));
    },
    removeFromMessgeraete: (state, action: PayloadAction<messgeraet>) => {
      const updateIndex = state.messgeraetListe.findIndex(
        (x) => x.id == action.payload.id
      );
      const firstPart = state.messgeraetListe.slice(0, updateIndex);
      let lastPart = Array<messgeraet>();
      if (updateIndex + 1 < state.messgeraetListe.length)
        lastPart = state.messgeraetListe.slice(updateIndex + 1);
      state.messgeraetListe = [...firstPart, ...lastPart];
    },
    setMessgeraete: (state, action: PayloadAction<Array<messgeraet>>) => {
      state.messgeraetListe = action.payload;
    },
    setIdAktuellesMessgeraet: (state, action: PayloadAction<number>) => {
      state.aktuellesMessgereat.id = action.payload;
    },
    setAktuellesMessgeraet: (state, action: PayloadAction<messgeraet>) => {
      state.aktuellesMessgereat = action.payload;
      state.altesMessgeraet = action.payload;
    },
    setAltesMessgeraet: (state, action: PayloadAction<messgeraet>) => {
      state.altesMessgeraet = action.payload;
    },
    resetAktuellesMessgeraet: (state) => {
      state.aktuellesMessgereat = state.altesMessgeraet;
    },
    setZSs: (state, action: PayloadAction<Array<zeitsynchronisationsart>>) => {
      state.zsList = action.payload;
    },
    setZS: (state, action: PayloadAction<string | null>) => {
      state.aktuellesMessgereat.zeitsynchronisationsart = action.payload;
      state.editDirty =
        state.aktuellesMessgereat.zeitsynchronisationsart ==
          state.altesMessgeraet.zeitsynchronisationsart
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setMessgeraettypen: (
      state,
      action: PayloadAction<Array<messgeraettyp>>
    ) => {
      state.messgeraettypList = action.payload;
    },
    setMessgeraetetyp: (state, action: PayloadAction<number>) => {
      state.aktuellesMessgereat.typ = action.payload;
      state.editDirty =
        state.aktuellesMessgereat.typ == state.altesMessgeraet.typ
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setSeriennummer: (state, action: PayloadAction<string>) => {
      state.aktuellesMessgereat.seriennummer = action.payload;
      state.editDirty =
        state.aktuellesMessgereat.seriennummer ==
          state.altesMessgeraet.seriennummer
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setHerstellungsjahr: (state, action: PayloadAction<number>) => {
      state.aktuellesMessgereat.herstellungsjahr = action.payload;
      state.editDirty =
        state.aktuellesMessgereat.herstellungsjahr ==
          state.altesMessgeraet.herstellungsjahr
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setFirmware: (state, action: PayloadAction<string>) => {
      state.aktuellesMessgereat.firmware = action.payload;
      state.editDirty =
        state.aktuellesMessgereat.firmware == state.altesMessgeraet.firmware
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setMACAdresse: (state, action: PayloadAction<string | null>) => {
      state.aktuellesMessgereat.macadresse = action.payload == "" ? null : action.payload;
      state.editDirty =
        state.aktuellesMessgereat.macadresse == state.altesMessgeraet.macadresse
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setKommentar: (state, action: PayloadAction<string | null>) => {
      state.aktuellesMessgereat.kommentar = action.payload == "" ? null : action.payload;
      state.editDirty =
        state.aktuellesMessgereat.kommentar == state.altesMessgeraet.kommentar
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setInbetriebnahmedatum: (state, action: PayloadAction<Date | null>) => {
      if (action.payload != null) {
        state.aktuellesMessgereat.inbetriebnahmedatum = new Date(
          action.payload.getTime() - action.payload.getTimezoneOffset() * 60000
        ).toISOString();
      }
      else {
        state.aktuellesMessgereat.inbetriebnahmedatum = null
      }
      state.editDirty =
        state.aktuellesMessgereat.inbetriebnahmedatum ==
          state.altesMessgeraet.inbetriebnahmedatum
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setWartungsintervall: (state, action: PayloadAction<string | null>) => {
      state.aktuellesMessgereat.wartungsintervall = action.payload;
      state.editDirty =
        state.aktuellesMessgereat.wartungsintervall ==
          state.altesMessgeraet.wartungsintervall
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setIp: (state, action: PayloadAction<string | null>) => {
      state.aktuellesMessgereat.ipadresse = action.payload == "" ? null : action.payload;
      state.editDirty =
        state.aktuellesMessgereat.ipadresse == state.altesMessgeraet.ipadresse
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setSubnetzmaske: (state, action: PayloadAction<string | null>) => {
      state.aktuellesMessgereat.subnetzmaske = action.payload == "" ? null : action.payload;
      state.editDirty =
        state.aktuellesMessgereat.subnetzmaske == state.altesMessgeraet.subnetzmaske
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setEditEntry: (state) => {
      state.editEntry = true;
    },
    resetEditEntry: (state) => {
      state.editEntry = false;
    },
    setNewEntry: (state) => {
      state.newEntry = true;
    },
    resetNewEntry: (state) => {
      state.newEntry = false;
    },
    resetEditDirty: (state) => {
      state.editDirty = 0;
    },
    setViewMode: (state) => {
      state.viewMode = true;
    },
    resetViewMode: (state) => {
      state.viewMode = false;
    },
    setError: (state, action: PayloadAction<string>) => {
      if (!state.error.includes(action.payload)) {
        state.error.push(action.payload);
      }
    },
    resetError: (state, action: PayloadAction<string>) => {
      if (state.error.includes(action.payload)) {
        state.error.splice(state.error.indexOf(action.payload), 1)
      }
    },
    setWartungsintervalleList: (state, action: PayloadAction<Array<wartungsintervall>>) => {
      state.wartungsintervalle = action.payload;
    },
    setListLoading: (state, action: PayloadAction<boolean>) => {
      state.listLoading = action.payload;
    },
    setMessgeraettypenLoading: (state, action: PayloadAction<boolean>) => {
      state.messgeraettypenLoading = action.payload;
    },
    setZeitsynchroLoading: (state, action: PayloadAction<boolean>) => {
      state.zeitsynchroLoading = action.payload;
    },
    setWartungsintervallLoading: (state, action: PayloadAction<boolean>) => {
      state.wartungsintervallLoading = action.payload;
    },
    setSorting: (state, action: PayloadAction<GridSortModel>) => {
      state.sorting = action.payload;
    },
  },
});

//Selectors
//======================================================================
export const selectMessgeraete = (state: RootState): messgeraet[] =>
  state.messgeraete.messgeraetListe;
export const selectAktuellesMessgeraet = (state: RootState): messgeraet =>
  state.messgeraete.aktuellesMessgereat;
export const selectZSs = (state: RootState): zeitsynchronisationsart[] => state.messgeraete.zsList;
export const selectMessgeraetetyp = (state: RootState): messgeraettyp[] =>
  state.messgeraete.messgeraettypList;
export const selectEditEntry = (state: RootState): boolean =>
  state.messgeraete.editEntry;
export const selectNewEntry = (state: RootState): boolean => state.messgeraete.newEntry;
export const selectEditDirty = (state: RootState): number =>
  state.messgeraete.editDirty;
export const selectViewMode = (state: RootState): boolean => state.messgeraete.viewMode;
export const selectError = (state: RootState): boolean => state.messgeraete.error.length > 0;
export const selectWartungsintervalleList = (state: RootState): Array<wartungsintervall> => state.messgeraete.wartungsintervalle;
export const selectListLoading = (state: RootState): boolean => state.messgeraete.listLoading;
export const selectMessgeraettypenLoading = (state: RootState): boolean => state.messgeraete.messgeraettypenLoading;
export const selectZeitsynchroLoading = (state: RootState): boolean => state.messgeraete.zeitsynchroLoading;
export const selectWartungsintervallLoading = (state: RootState): boolean => state.messgeraete.wartungsintervallLoading;
export const selectSorting = (state: RootState): GridSortModel => state.messgeraete.sorting;


//Actions
//=====================================================================
export const getMessgeraete = (idString: string | undefined) => (dispatch: AppDispatch): void => {
  dispatch(setListLoading(true));
  getWithAuth("MESSGERAET", {})
    .then((response: Array<messgeraet>) => {
      dispatch(setMessgeraete(response));
      if (idString) {
          const id = Number(idString);
          const entry = response.find(x => x.id == id);
          if (entry) dispatch(updateAktuellesMessgeraet(entry));
      }
    })
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));
};

export const getZSs = () => (dispatch: AppDispatch): void => {
  dispatch(setZeitsynchroLoading(true));
  getWithAuth("ZEITSYNCHRONISATIONSART", {})
    .then((response) => {
      dispatch(setZSs(response));
    })
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setZeitsynchroLoading(false)));
};

export const getMessgeraettypen = () => (dispatch: AppDispatch): void => {
  dispatch(setMessgeraettypenLoading(true));
  getWithAuth("MESSGERAETTYP", {})
    .then((response) => {
      dispatch(setMessgeraettypen(response));
    })
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setMessgeraettypenLoading(false)));
};

export const updateAktuellesMessgeraet = (aktuellesMessgeraet: messgeraet): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch,
  getState: () => RootState
) => {
  if (!getState().messgeraete.editEntry) {
    dispatch(setAktuellesMessgeraet(aktuellesMessgeraet));
    dispatch(setViewMode());
  }
};

export const updateZS = (zs: string) => (dispatch: AppDispatch): void => {
  dispatch(setZS(zs));
};

export const updateMessgeraet = (aktuellesMessgeraet: messgeraet): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setListLoading(true));
  putWithAuth("MESSGERAETID", {}, aktuellesMessgeraet, aktuellesMessgeraet.id.toString())
    .then(() => {
      dispatch(
        openSnackbar({
          message: `Messgerät mit Seriennummer ${aktuellesMessgeraet.seriennummer} wurde erfolgreich geändert.`,
          severity: "success",
          duration: 6000,
        })
      );
      dispatch(setAltesMessgeraet(aktuellesMessgeraet));
      dispatch(updateMessgeraete(aktuellesMessgeraet));
      dispatch(resetEditEntry());
      dispatch(resetNewEntry());
      dispatch(resetEditDirty());
    }
    )
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));

};

export const discardChanges = () => (dispatch: AppDispatch): void => {
  dispatch(resetAktuellesMessgeraet());
  dispatch(resetEditEntry());
  dispatch(resetNewEntry());
  dispatch(resetEditDirty());
};

export const discardNew = () => (dispatch: AppDispatch): void => {
  dispatch(resetAktuellesMessgeraet());
  dispatch(resetEditEntry());
  dispatch(resetNewEntry());
  dispatch(resetEditDirty());
  dispatch(resetViewMode());
};

export const startNewEntry = () => (dispatch: AppDispatch): void => {
  dispatch(setNewEntry());
  dispatch(setAktuellesMessgeraet(messgeraetDummy));
  dispatch(setEditEntry());
  dispatch(setViewMode());
};

export const createMessgeraet = (aktuellesMessgeraet: messgeraet): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setListLoading(true));
  postJsonWithAuth("MESSGERAET", {}, {
    id: aktuellesMessgeraet.id,
    seriennummer: aktuellesMessgeraet.seriennummer,
    herstellungsjahr: aktuellesMessgeraet.herstellungsjahr,
    firmware: aktuellesMessgeraet.firmware,
    macadresse: aktuellesMessgeraet.macadresse,
    kommentar: aktuellesMessgeraet.kommentar,
    inbetriebnahmedatum: aktuellesMessgeraet.inbetriebnahmedatum,
    wartungsintervall: aktuellesMessgeraet.wartungsintervall,
    zeitsynchronisationsart: aktuellesMessgeraet.zeitsynchronisationsart,
    typ: aktuellesMessgeraet.typ,
    ipadresse: aktuellesMessgeraet.ipadresse,
    subnetzmaske: aktuellesMessgeraet.subnetzmaske,
    zugeordnet: aktuellesMessgeraet.zugeordnet,
    jemalsZugeordnet: aktuellesMessgeraet.jemalsZugeordnet
  })
    .then((response) => {
      dispatch(
        openSnackbar({
          message: `Messgerät mit Seriennummer ${aktuellesMessgeraet.seriennummer} wurde erfolgreich angelegt.`,
          severity: "success",
          duration: 6000,
        })
      );
      dispatch(setIdAktuellesMessgeraet(response));
      dispatch(addAktuellesMessgeraetToMessgeraete());
      dispatch(setAktuellesMessgeraet(messgeraetDummy));
      dispatch(resetEditEntry());
      dispatch(resetNewEntry());
      dispatch(resetEditDirty());
      dispatch(resetViewMode());
    }
    )
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));

};

export const deleteMessgeraet = (aktuellesMessgeraet: messgeraet): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setListLoading(true));
  deleteWithAuth("MESSGERAETID", {}, aktuellesMessgeraet.id.toString())
    .then(() => {
      dispatch(setAktuellesMessgeraet(messgeraetDummy));
      dispatch(removeFromMessgeraete(aktuellesMessgeraet));
      dispatch(resetEditEntry());
      dispatch(resetEditDirty());
      dispatch(resetViewMode());
      dispatch(openSnackbar({
        message: `${aktuellesMessgeraet.seriennummer} wurde erfolgreich gelöscht.`,
        severity: "success",
        duration: 6000,
      }));
    }
    )
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));
};

export const getWartungsintervalle = () => (dispatch: AppDispatch): void => {
  dispatch(setWartungsintervallLoading(true));
  getWithAuth("WARTUNGSINTERVALL", {})
    .then((response) => {
      dispatch(setWartungsintervalleList(response));
    })
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setWartungsintervallLoading(false)));
};

export const {
  setMessgeraete,
  setAktuellesMessgeraet,
  removeFromMessgeraete,
  setZSs,
  setMessgeraettypen,
  setZS,
  setMessgeraetetyp,
  resetAktuellesMessgeraet,
  setHerstellungsjahr,
  setFirmware,
  setMACAdresse,
  setKommentar,
  setInbetriebnahmedatum,
  setWartungsintervall,
  setIp,
  setSubnetzmaske,
  setAltesMessgeraet,
  updateMessgeraete,
  setEditEntry,
  resetEditEntry,
  setNewEntry,
  resetNewEntry,
  setSeriennummer,
  resetEditDirty,
  setViewMode,
  resetViewMode,
  setError,
  resetError,
  setIdAktuellesMessgeraet,
  addAktuellesMessgeraetToMessgeraete,
  setWartungsintervalleList,
  setListLoading,
  setMessgeraettypenLoading,
  setZeitsynchroLoading,
  setWartungsintervallLoading,
  setSorting
} = messgereateSlice.actions;
export default messgereateSlice.reducer;
